import {api} from "@/lib/api/wallet/api";

interface IAttachSmsTagsRequest {
    tags: string[];
}

export const smsTagApi = api.injectEndpoints({
    endpoints: build => ({
        attachSmsTags: build.mutation<void, IAttachSmsTagsRequest>({
            query: (body) => ({
                url: '/api/v1/tags/attach',
                method: 'post',
                body,
            })
        }),
    })
})

export const {useAttachSmsTagsMutation} = smsTagApi;
